import script from "./ResumenJugador.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumenJugador.vue?vue&type=script&setup=true&lang=ts"

import "./ResumenJugador.vue?vue&type=style&index=0&id=d1af9aaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1af9aaa"]])

export default __exports__